<template>
  <div>
    <span class="legend-title">{{ $t('Webportal.Legend') }}:</span>
    <div class="legend-list">
      <div  v-for="legend in legends"
            :key="legend.key"
            class="legend-item">
        <span class="legend-label">{{ legend.label }}</span>
        <div class="legend-values">
          <div  v-for="value in legend.values"
                :key="value.label"
                class="legend-value">
            <component  v-if="value.icon"
                        :is="value.icon"
                        :size="12"
                        class="value-icon" />
            <div  v-else
                  class="color-indicator"
                  :style="{ backgroundColor: value.color }">
            </div>
            <span class="value-text">{{ value.label }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Snowflake } from 'lucide-vue-next';

export default {
  name: 'LegendList',

  components: {
    Snowflake
  },

  props: {
    legends: {
      type: Array,
      default: () => [
        {
          key: 'performance',
          label: 'Performance Index (%)',
          values: [
            { label: '75-100', color: '#22c55e' },
            { label: '50-75', color: '#eab308' },
            { label: '0-49', color: '#ef4444' }
          ]
        },
        // {
        //   key: 'lead-followup',
        //   label: 'Performance Index (Lead Follow up)',
        //   values: [
        //     { label: '100', color: 'rgb(5, 223, 114)' },
        //     { label: '90-99', color: 'rgb(240, 177, 0)' },
        //     { label: '0-89', color: 'rgb(255, 100, 103)' }
        //   ]
        // },
        // {
        //   key: 'lm-xev',
        //   label: 'Performance Index (LM/xEV/App)',
        //   values: [
        //     { label: '90-100', color: 'rgb(5, 223, 114)' },
        //     { label: '80-89', color: 'rgb(240, 177, 0)' },
        //     { label: '0-79', color: 'rgb(255, 100, 103)' }
        //   ]
        // },
        // {
        //   key: 'test-drive',
        //   label: 'Performance Index (Test Drive)',
        //   values: [
        //     { label: '80-100', color: 'rgb(5, 223, 114)' },
        //     { label: '50-79', color: 'rgb(240, 177, 0)' },
        //     { label: '0-49', color: 'rgb(255, 100, 103)' }
        //   ]
        // },
        // {
        //   key: 'data-freeze',
        //   label: 'Data Freeze',
        //   values: [
        //     { label: 'Daten eingefroren', icon: Snowflake }
        //   ]
        // }
      ]
    }
  }
};
</script>

<style lang="scss" scoped>
.legend-list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 1rem;
}

.legend-title {
  font-size: 0.8125rem;
  color: var(--bs-secondary-color);
}

.legend-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 15rem;
}

.legend-label {
  font-size: 0.6875rem;
  font-weight: 700;
  color: var(--bs-body-color);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.legend-values {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
}

.legend-value {
  display: flex;
  align-items: center;
  gap: 6px;
}

.color-indicator {
  width: 4px;
  height: 14px;
  border-radius: var(--radius-xs);
}

.value-icon {
  flex-shrink: 0;
  color: var(--bs-secondary-color);
}

.value-text {
  font-size: 0.6875rem;
  color: var(--bs-secondary-color);
}
</style>
